export enum SortMode {
    DateAscending = 'date-ascending',
    DateDescending = 'date-descending'
}